import capitalize from '../../../../Helpers/StringsFormatting/capitalize';

export const pct = (num, den) => (den ? Math.round((num / den) * 100) : 0);

// Unrounded percentage (redemption is shown with decimals, like desktop's
// `.toFixed(2)%`).
export const rate = (num, den) => (den ? (num / den) * 100 : 0);

// [firstDay, lastDay] of the month at `offset` months from the current one.
export const monthRange = (offset) => {
  const now = new Date();
  const first = new Date(now.getFullYear(), now.getMonth() + offset, 1);
  const last = new Date(
    now.getFullYear(),
    now.getMonth() + offset + 1,
    0,
    23,
    59,
    59
  );
  return [first, last];
};

// Desktop outcome-label rule: translate the uppercased name, else capitalize.
export const outcomeLabel = (intl, name) =>
  intl.messages[name?.toUpperCase()] ?? capitalize(name) ?? name;

// Desktop automatic colors: outcome.color is a { light, dark } pair resolved by
// the active theme mode (matches OutcomeCallsWidget / SectionDonutPaper).
export const resolveColor = (theme, outcome, mode) => {
  const color = outcome?.color;
  if (!color) return theme.custom.stringToColor(outcome?.name || '');
  return typeof color === 'string' ? color : (color[mode] ?? color.light);
};
